import { ReactNode, useState } from 'react';
import { Button } from '../../../../design-system/button/button';
import { Inline } from '../../../../design-system/inline/inline';
import { Stack } from '../../../../design-system/stack/stack';
import { reportingCalloutStorage } from '../../utils/reporting-callout-storage';

export type AddAllAccountsCalloutProps = {
  title?: ReactNode;
  description?: string;
  onLinkAllAccounts: () => void;
  onComplete: () => void;
  className?: string;
};

export const AddAllAccountsCallout = ({
  title = 'Have you linked all of your bank accounts',
  description = 'To ensure the cashflow information on this page are accurate we recommend linking all of your bank accounts',
  onLinkAllAccounts,
  onComplete,
  className = '',
}: AddAllAccountsCalloutProps) => {
  const isDismissed = reportingCalloutStorage.getDismissed();
  const [isClosing, setIsClosing] = useState(false);

  const handleCompleteClick = () => {
    setIsClosing(true);
  };

  if (isDismissed) {
    return null;
  }

  return (
    <div
      data-testid="add-accounts-callout"
      className={
        `w-full rounded-xl border-[0.5px] border-seapoint-gray-border bg-white ${className}` +
        `${isClosing ? 'pointer-events-none max-h-0 overflow-hidden p-0 opacity-0 transition-all duration-300 ease-in-out' : 'max-h-96 overflow-hidden p-4 opacity-100 transition-all duration-300 ease-in-out'}`
      }
      onTransitionEnd={() => {
        if (isClosing) {
          onComplete?.();
        }
      }}
    >
      <Inline className="w-full justify-between" space={4}>
        <Stack space={1} className="">
          <h3 className="text-base font-semibold text-black">{title}</h3>
          <p className="text-sm font-medium text-seapoint-gray-text">{description}</p>
        </Stack>

        <Inline space={6} wrap="nowrap" className="mt-5 sm:mt-0">
          <Button
            variant="link"
            size="none"
            rounded={false}
            onClick={onLinkAllAccounts}
            className="text-seapoint-blue-link"
          >
            Link Bank Account
          </Button>

          <Button
            variant="link"
            size="none"
            rounded={false}
            onClick={handleCompleteClick}
            disabled={!onComplete}
            className="text-seapoint-blue-link"
          >
            Complete
          </Button>
        </Inline>
      </Inline>
    </div>
  );
};
